export enum ActionTypes {
  GET_UXRS_TRAITS_REQUEST = "@@uxr_traits/GET_UXRS_TRAITS_REQUEST",
  GET_UXRS_TRAITS_SUCCESS = "@@uxr_traits/GET_UXRS_TRAITS_SUCCESS",
  GET_UXRS_TRAITS_FAILURE = "@@uxr_traits/GET_UXRS_TRAITS_FAILURE",

  CREATE_UXRS_TRAITS_REQUEST = "@@uxr_traits/CREATE_UXRS_TRAITS_REQUEST",
  CREATE_UXRS_TRAITS_SUCCESS = "@@uxr_traits/CREATE_UXRS_TRAITS_SUCCESS",
  CREATE_UXRS_TRAITS_FAILURE = "@@uxr_traits/CREATE_UXRS_TRAITS_FAILURE",
}
